import type { TFunction } from 'i18next'
import type { ActivityWithSessions } from '../../../types/GeneralTypes'
import { buildSprintTeamDisplayBuckets } from 'pure-js/libs/buildSprintTeamDisplayBuckets'
import type { SprintTeamDetail } from '../../../types/TrainingSprintTypes'

export type TeamDisplayBuckets = {
  teamDetails: SprintTeamDetail[]
  unassignedMemberNames: string[]
}

/**
 * Uses API `teamDetails` when present; otherwise groups participants by `teamId` for older payloads.
 */
export function getTeamDisplayBucketsForActivity(activity: ActivityWithSessions, t: TFunction): TeamDisplayBuckets {
  const hasApiBuckets = activity.teamDetails !== undefined || activity.unassignedMemberNames !== undefined

  if (hasApiBuckets) {
    return {
      teamDetails: activity.teamDetails ?? [],
      unassignedMemberNames: activity.unassignedMemberNames ?? []
    }
  }

  const participants = activity.participants ?? []
  const teamIds = [...new Set(participants.map((p) => p.teamId).filter(Boolean))] as string[]

  const syntheticTeams = teamIds.map((tempTeamId, index) => ({
    name: t('gamer.upcomingActivities.teamsSection.teamFallback', { index: index + 1 }),
    tempTeamId
  }))

  return buildSprintTeamDisplayBuckets({
    teams: syntheticTeams,
    participants
  })
}
